"use client";
import { formatDate, formatDateTime } from "@/lib/utils";
import {
  PublicationsData,
  PublicationType,
} from "@/services/publications/types";
import { Breadcrumb } from "@ama-pt/agora-design-system";
import VideoPlayer from "./VideoPlayer";
import Image from "@/components/atoms/image";
import NotFound from "@/app/[locale]/not-found";
import { useLocale, useTranslations } from "next-intl";
import { RichText } from "../RichText/RichText";
import Heading from "@/components/molecules/Heading";
interface PublicationPageClientProps {
  publicationData: PublicationsData;
  content: any;
}

export function PublicationPageClient({
  publicationData,
}: PublicationPageClientProps) {
  const t = useTranslations();
  const locale = useLocale();
  const data = publicationData.items[0];
  if (!data) {
    return NotFound();
  }

  const isVideo = data.publicationType === PublicationType.VIDEO;

  return (
    <div className="">
      <div className="py-24">
        <div className="container mx-auto">
          <Breadcrumb
            items={[
              {
                label: t("Breadcrumb.homePage"),
                url: "/",
              },
              {
                label: t("Breadcrumb.aboutUs"),
                url: locale === "pt" ? "/sobre-nos" : "/about-bupi",
              },
              {
                label: t("Breadcrumb.average"),
                url: "/media",
              },
              {
                label: isVideo ? t("Breadcrumb.videos") : t("Breadcrumb.pressReleases"),
                url: isVideo ? "/videos" : locale === "pt" ? "/comunicados-a-imprensa" : "/press-releases",
              },
              {
                label: data.title,
                url: "",
              },
            ]}
          />
        </div>
        <div className="container mx-auto md:mt-64 mt-32">
          <div
            className={`text-xl-regular md:text-2xl-regular md:max-w-[90%] xl:text-3xl-regular bg-no-repeat bg-[length:100%_50%] bg-top`}
            style={{
              display: "inline",
              boxDecorationBreak: "clone",
              WebkitBoxDecorationBreak: "clone",
              backgroundImage: `linear-gradient(to bottom,#F1F6F3,#F1F6F3)`,
            }}
          >
            <Heading title={data?.richtitle || data?.title} />
          </div>
          {data?.publishedAt && (
            <time
              className="block mt-16 text-m-regular text-neutral-900"
              dateTime={formatDateTime(data?.publishedAt)}
            >
              {formatDate(data.publishedAt)}
            </time>
          )}
        </div>
        <div className="container mx-auto py-64 px-0 md:px-64 xl:px-128">
          <div className="text-m-regular text-neutral-900 max-w-[80ch] mx-auto">
            {isVideo ? (
              <div className="float-left w-2/3 pr-32 pb-16">
                <VideoPlayer
                  videoUrl={data?.midia?.url || data?.youtubeUrl}
                  videoSource={data?.youtubeUrl !== "" && data?.youtubeUrl !== null ? "youtube" : "upload"}
                  posterImage={data.featuredImage?.url}
                />
              </div>
            ) : (
              data?.featuredImage?.url && (
                <div className="float-left w-2/3 pr-32 pb-16">
                  <Image
                    src={data.featuredImage.url}
                    alt={data.featuredImage.alt || data.title}
                    width={0}
                    height={0}
                    sizes="50vw"
                    className="w-full rounded"
                    priority
                  />
                </div>
              )
            )}
            {data?.publicationType !== "pressRelease" && <p className="text-s-bold text-primary-500"> {data?.region && t("Filters." + data?.region)} </p> }
            {data?.contentText && (
              <RichText
                content={data.contentText}
                className="text-m-regular !max-w-[80ch] text-neutral-900 pb-8 prose prose-ul:my-0 marker:text-neutral-900"
              />
            )}
            {data?.updatedAt && (
              <time
                className="block mt-16 text-m-regular text-neutral-900"
                dateTime={formatDateTime(data?.updatedAt)}
              >
                {t("Carlist.updatedAt")}: {formatDate(data.updatedAt)}
              </time>
            )}
            <div className="clear-both" />
          </div>
        </div>
      </div>
    </div>
  );
}
